<div class="left-hlf">
  <div class="logo">
    <img src="./assets/logo-210.svg">
  </div>
  @if (greeting) {
    <div class="id-header">
      <div class="welcome">
        <p class="dark">{{ greeting.dark }}</p>
        <p class="gold">{{ greeting.gold }}</p>
      </div>
      @if (greeting.subheader) {
        <h4 class="subheader">{{ greeting.subheader }}</h4>
      }
      @if (greeting.paragraph) {
        <p class="paragraph">{{ greeting.paragraph }}</p>
      }
    </div>
  }
</div>
